/*

File is used to populate floor plans 

*/
import THREE from 'particlespace-graphics-engine'

var FloorPlanRenderer = Class.create({
    height: 0,
	width: 0,
  	initialize: function() {

  	},
    setUpWindowSize: function() {
        var computedHeight = (jQuery("#main").height() - jQuery("#main nav").height());
        var shaveOff = computedHeight * .1;
        computedHeight = computedHeight - shaveOff;;

        this.height = computedHeight;
        this.width = jQuery("#main").width();
	},
	setUpWindowSizeBaseOnDOM: function(domName) {
        this.height = jQuery(domName).height();
		this.width = jQuery(domName).width();
	},
  	// #  Creates the grid used for each individual floor
  	createLevelViewGrid: function(cameraObj,canvasID,modelStep,modelSize,gridtype) {
        /*
		The purose of the continouse call is to handle cases
		where screen dimensions might change
		*/
		this.setUpWindowSize();
  		// # return obj
  		var returnObj = [];
  		// #  Setup our scene in which we will draw our canvas too.
		var scene = new THREE.Scene();
		var camera = cameraObj.cam;//new THREE.PerspectiveCamera( 40, window.innerWidth / window.innerHeight, 1, 10000 );
		//camera.position.set(500, 500, 1300);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
		//camera.lookAt( new THREE.Vector3());
		// #  Send over to build grid geometry and return
		var response = this.buildGridGeometry(modelStep,modelSize,gridtype);
		var geometry = response['geometry'];
		geometry.computeBoundingBox();
		// #  Setup the material
		var material = new THREE.LineBasicMaterial( { color: 0x000000, opacity: 0.2 } );
		// #  Draw each individual line
		var gridFrame = new THREE.Line( geometry, material, THREE.LinePieces );

		//var line = THREE.Mesh(geometry);
		// #  Add to our scene
		scene.add( gridFrame );
		// #  Setup our raycaster
		var raycaster = new THREE.Raycaster();


		// #  Setup plan geometry

		var extrudeSettings = { amount: 1, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
		var buildingGeometry = new THREE.ExtrudeGeometry( response['buildingShape'], extrudeSettings );
		buildingGeometry.computeBoundingBox();

		// #  Setup building material
		var materialFront = new THREE.MeshBasicMaterial({color: 0x676767 ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
		var materialSide = new THREE.MeshBasicMaterial({color: 0x676767 ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
		var materialArray = [ materialFront, materialSide ];
		var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
		var underlineGrid = new THREE.Mesh( buildingGeometry, materialFront );
		underlineGrid.rotateX( -(Math.PI / 2) );
		underlineGrid.visible = false;
		// #  Add to scene
		scene.add( underlineGrid );
		
		//geometry.faces.push( new THREE.Face3( 0, 1, 2 ) );
//geometry.computeFaceNormals();
		//var outOfBoundsPlane = new THREE.Mesh( geometry, new THREE.materialFront() );
		var geometry = new THREE.PlaneBufferGeometry( 1000, 1000 );

		geometry.applyMatrix( new THREE.Matrix4().makeRotationX( - Math.PI / 2 ) );
		geometry.computeBoundingBox();
		// #  Attach mesh to plane
		var outOfBoundsPlane = new THREE.Mesh( geometry );
		outOfBoundsPlane.visible = false;
		// #  Add to scene
		scene.add( outOfBoundsPlane );
		
		// #  Type of material
		var material = new THREE.MeshBasicMaterial( { color: 0xff0000, wireframe: false } );	
		// # Lights
		var ambientLight = new THREE.AmbientLight( 0x606060 );
		// #  Add to scene
		scene.add( ambientLight );
		// #  Setup directional lighting - use as sun.
		var directionalLight = new THREE.DirectionalLight( 0xffffff );
		directionalLight.position.x = -0.6904170611197439;
		directionalLight.position.y = -0.4266471307640398;
		directionalLight.position.z = 0.5842058776883268;
		directionalLight.position.normalize();
		// #  Add to scene
		scene.add( directionalLight );
		var directionalLight = new THREE.DirectionalLight( 0x808080 );
		directionalLight.position.x = -0.3767783309390417;
		directionalLight.position.y = 0.7141727452598452;
		directionalLight.position.z = -0.5899113316955407;
		directionalLight.position.normalize();
		// #  Add to scene
		scene.add( directionalLight );
		// #  Setup our renderer
		var renderer = new THREE.CanvasRenderer();
		// #  Setup our color for the background
		renderer.setClearColor( 0xffffff );//0xf0f0f0
		// #  We need to dynamically set our width
		renderer.setSize( this.width, this.height );
		
		renderer.render( scene, camera );
		// #  Setup our return obj
		returnObj.push(renderer);
		returnObj.push(camera);
		returnObj.push(scene);
		returnObj.push(underlineGrid);// was plane
		returnObj.push(raycaster);
		returnObj.push(gridFrame);
		returnObj.push(outOfBoundsPlane);
		// #  Return
		return returnObj;
  	},
  	// #  The main use of this function is to pass a id to store our mini floor plan
  	createMini3DModel: function(context,modelStep,modelSize,gridtype) {
		/*
		The purose of the continouse call is to handle cases
		where screen dimensions might change
		*/
		this.setUpWindowSizeBaseOnDOM("#floor-plan-card-holder");
  		// #  Setup our scene in which we will draw our canvas too.
		var scene = new THREE.Scene();
		var camera = new THREE.PerspectiveCamera(40,this.width / this.height,1,10000);
		camera.position.set(500, 500, 1300);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
		camera.lookAt( new THREE.Vector3());
		// #  Send over to build grid geometry and return
		var response = this.buildGridGeometry(modelStep,modelSize,gridtype, true);
		// #  Setup the material
		var material = new THREE.LineBasicMaterial( { color: 0x000000, opacity: 0.2 } );
		// #  Draw each individual line
		var line = new THREE.Line( response['geometry'], material, THREE.LinePieces );
		// #  Add to our scene
		scene.add( line );
		// #  Setup our raycaster
		var raycaster = new THREE.Raycaster();
		// #  Setup plan geometry
		var geometry = new THREE.PlaneBufferGeometry( 1000, 1000 );
		geometry.applyMatrix( new THREE.Matrix4().makeRotationX( - Math.PI / 2 ) );
		geometry.computeBoundingBox();
		// #  Attach mesh to plane
		var plane = new THREE.Mesh( geometry );
		plane.visible = false;
		// #  Add to scene
		scene.add( plane );
		// #  Type of material
		var material = new THREE.MeshBasicMaterial( { color: 0xff0000, wireframe: false } );	
		// # Lights
		var ambientLight = new THREE.AmbientLight( 0x606060 );
		// #  Add to scene
		scene.add( ambientLight );
		// #  Setup directional lighting - use as sun.
		var directionalLight = new THREE.DirectionalLight( 0xffffff );
		directionalLight.position.x = Math.random() - 0.5;
		directionalLight.position.y = Math.random() - 0.5;
		directionalLight.position.z = Math.random() - 0.5;
		directionalLight.position.normalize();
		// #  Add to scene
		scene.add( directionalLight );
		var directionalLight = new THREE.DirectionalLight( 0x808080 );
		directionalLight.position.x = Math.random() - 0.5;
		directionalLight.position.y = Math.random() - 0.5;
		directionalLight.position.z = Math.random() - 0.5;
		directionalLight.position.normalize();
		// #  Add to scene
		scene.add( directionalLight );
		// #  Setup our color for the background
		context.state.renderer.setClearColor( 0xffffff );
		// #  We need to dynamically set our width
		context.state.renderer.setSize( this.width, this.height );
		context.state.renderer.render( scene, camera );

		context.setState({
            updateCanvas: true
        });
		// #  Setup our renderer
		//var renderer = new THREE.CanvasRenderer();
		// #  Setup our color for the background
		/*renderer.setClearColor( 0xffffff );//0xf0f0f0
		// #  We need to dynamically set our width
		renderer.setSize( this.width, this.height );
		// #  Attach our renderer to our container
		container.appendChild(renderer.domElement);
		renderer.render( scene, camera );
		// #  Setup our return obj
		returnObj.push(container);
		returnObj.push(renderer);

		// #  Return
		return returnObj;*/
  	},
  	buildGridGeometry: function(modelStep,modelSize,gridtype, isMini = false) {
  		// #  Setup our size and step 
		var size = parseInt(modelSize - 100), halfSize = Math.round(size / 2),step = parseInt(modelStep);
  		// #  Fire geometry
		var geometry = new THREE.Geometry();

		var underlineGrid = new THREE.Shape();

  		// #  Determine our grid type and process accordingly
		if(gridtype == "TR-L"){
			// #  Create top right L section
			underlineGrid.moveTo( -size, -size );
			underlineGrid.lineTo( -size, size );
			underlineGrid.lineTo( size, size );
			underlineGrid.lineTo( size, 0 );
			// #  S tart the bottom section
			underlineGrid.lineTo( 0, 0);
			underlineGrid.lineTo( 0, -size );
			underlineGrid.lineTo( -size, -size );


			var activateHalfSize = false;
			var initialHalfSizeleftright = 0,initialHalfSizetopbottom = 0;  // #  adds addiitional line to end of half way point
			// #  Loop throuhg our verticies to create the grid.
			for ( var i = - size; i <= size; i += step ) {
				if(i == 0) // #  midway point
				{ 
					activateHalfSize = true;
				}

				if(activateHalfSize)
				{
					if(initialHalfSizeleftright == 0 && initialHalfSizetopbottom == 0)
					{
						geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3(   size, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
						geometry.vertices.push( new THREE.Vector3( i, 0,   size ) );
						initialHalfSizeleftright = 1,initialHalfSizetopbottom = 1;
					}
					else 
					{
						geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( 0, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( i , 0, - size ) );
						geometry.vertices.push( new THREE.Vector3( i , 0,  0 ) );
					}
				}
				else {
					geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
					geometry.vertices.push( new THREE.Vector3(   size, 0, i ) );

					geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
					geometry.vertices.push( new THREE.Vector3( i, 0,   size ) );
				}
			}
		}
		else if(gridtype == "BR-L"){

			// #  Create top right L section
			underlineGrid.moveTo( -size, -size );
			underlineGrid.lineTo( -size, size );
			underlineGrid.lineTo( 0, size );
			underlineGrid.lineTo( 0, 0 );
			// #  S tart the bottom section
			underlineGrid.lineTo( size, 0);
			underlineGrid.lineTo( size, -size );
			underlineGrid.lineTo( -size, -size );

			var activateHalfSize = false;
			var initialHalfSizeleftright = 0,initialHalfSizetopbottom = 0;  // #  adds addiitional line to end of half way point
			// #  Loop throuhg our verticies to create the grid.
			for ( var i = - size; i <= size; i += step ) {
				if(i == 0) // #  midway point
				{ 
					activateHalfSize = true;
				}

				if(activateHalfSize)
				{
					if(initialHalfSizeleftright == 0 && initialHalfSizetopbottom == 0)
					{
						geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3(   size, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
						geometry.vertices.push( new THREE.Vector3( i, 0,   size ) );

						initialHalfSizeleftright = 1,initialHalfSizetopbottom = 1;
					}
					else 
					{
						geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( size, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( i , 0,  size ) );
						geometry.vertices.push( new THREE.Vector3( i , 0,  0 ) );
					}
				}
				else {
					// #  Left to right
					geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
					geometry.vertices.push( new THREE.Vector3(   0, 0, i ) );
					// #  Up and Down
					geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
					geometry.vertices.push( new THREE.Vector3( i, 0,   size ) );
				}
			}
		}
		if(gridtype == "TL-L"){
			// #  Create top right L section
			underlineGrid.moveTo( size, -size );
			underlineGrid.lineTo( size, size );
			underlineGrid.lineTo( -size, size );
			underlineGrid.lineTo( -size, 0 );
			// #  S tart the bottom section
			underlineGrid.lineTo( 0, 0);
			underlineGrid.lineTo( 0, -size );
			underlineGrid.lineTo( size, -size );

			var activateHalfSize = false;
			var initialHalfSizeleftright = 0,initialHalfSizetopbottom = 0;  // #  adds addiitional line to end of half way point
			// #  Loop throuhg our verticies to create the grid.
			for ( var i = - size; i <= size; i += step ) {
				if(i == 0) // #  midway point
				{ 
					activateHalfSize = true;
				}

				if(activateHalfSize)
				{
					if(initialHalfSizeleftright == 0 && initialHalfSizetopbottom == 0)
					{
						geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3(   size, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
						geometry.vertices.push( new THREE.Vector3( i, 0,   size ) );

						initialHalfSizeleftright = 1,initialHalfSizetopbottom = 1;
					}
					else 
					{
						geometry.vertices.push( new THREE.Vector3( 0, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( size, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( i , 0,  - size ) );
						geometry.vertices.push( new THREE.Vector3( i , 0,  size ) );
					}
				}
				else {
					// #  Left to right
					geometry.vertices.push( new THREE.Vector3(  size, 0, i ) );
					geometry.vertices.push( new THREE.Vector3(   -size, 0, i ) );
					// #  Up and Down
					geometry.vertices.push( new THREE.Vector3( i, 0, -size ) );
					geometry.vertices.push( new THREE.Vector3( i, 0,   0 ) );
				}
			}
		}
		else if(gridtype == "BL-L"){
			// #  Create top right L section
			underlineGrid.moveTo( size, -size );
			underlineGrid.lineTo( size, size );
			underlineGrid.lineTo( 0, size );
			underlineGrid.lineTo( 0, 0 );
			// #  S tart the bottom section
			underlineGrid.lineTo( -size, 0);
			underlineGrid.lineTo( -size, -size );
			underlineGrid.lineTo( size, -size );

			var activateHalfSize = false;
			var initialHalfSizeleftright = 0,initialHalfSizetopbottom = 0;  // #  adds addiitional line to end of half way point
			// #  Loop throuhg our verticies to create the grid.
			for ( var i = - size; i <= size; i += step ) {
				if(i == 0) // #  midway point
				{ 
					activateHalfSize = true;
				}

				if(activateHalfSize)
				{
					if(initialHalfSizeleftright == 0 && initialHalfSizetopbottom == 0)
					{
						geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3(   size, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
						geometry.vertices.push( new THREE.Vector3( i, 0,   size ) );

						initialHalfSizeleftright = 1,initialHalfSizetopbottom = 1;
					}
					else 
					{
						geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( size, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( i , 0,  - size ) );
						geometry.vertices.push( new THREE.Vector3( i , 0,  size ) );
					}
				}
				else {
					// #  Left to right
					geometry.vertices.push( new THREE.Vector3(  size, 0, i ) );
					geometry.vertices.push( new THREE.Vector3(   0, 0, i ) );
					// #  Up and Down
					geometry.vertices.push( new THREE.Vector3( i, 0, 0 ) );
					geometry.vertices.push( new THREE.Vector3( i, 0,   size ) );
				}
			}
		}
		else if(gridtype == "Square"){
			// #  Create square
			underlineGrid.moveTo( -size, -size );
			underlineGrid.lineTo( -size, size );
			underlineGrid.lineTo( size, size );
			underlineGrid.lineTo( size, -size );
			underlineGrid.lineTo( -size, -size );

			for ( var i = - size; i <= size; i += step ) {

				geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
				geometry.vertices.push( new THREE.Vector3(   size, 0, i ) );

				geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
				geometry.vertices.push( new THREE.Vector3( i, 0,   size ) );
			}
		}
		else if(gridtype == "Rectangle"){
			underlineGrid.moveTo( -size, -size );
			underlineGrid.lineTo( -size, size );
			underlineGrid.lineTo( 0, size);
			underlineGrid.lineTo( 0, -size );
			underlineGrid.lineTo( -size, -size );

			var activateHalfSize = false;
			var initialHalfSizeleftright = 0,initialHalfSizetopbottom = 0;  // #  adds addiitional line to end of half way point
			// #  Loop throuhg our verticies to create the grid.
			for ( var i = - size; i <= size; i += step ) {
				if(i == 0) // #  midway point
				{ 
					activateHalfSize = true;
				}

				if(activateHalfSize)
				{
					if(initialHalfSizeleftright == 0 && initialHalfSizetopbottom == 0)
					{
						geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3(   0, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
						geometry.vertices.push( new THREE.Vector3( i, 0,   size ) );

						initialHalfSizeleftright = 1,initialHalfSizetopbottom = 1;
					}
					else
					{
						geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( 0, 0, i ) );
					}
				}
				else {
					geometry.vertices.push( new THREE.Vector3( -size, 0, i ) );
					geometry.vertices.push( new THREE.Vector3(   0, 0, i ) );

					geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
					geometry.vertices.push( new THREE.Vector3( i, 0,   size ) );
				}
			}
		} else if (gridtype == "TL-D"){
			if(isMini) {
				return this.buildMiniTLD(modelStep,modelSize,gridtype)
			}

			underlineGrid.moveTo( 0, 0 );
			underlineGrid.lineTo( size / 2, -150 );

			underlineGrid.lineTo( size / 2, -size );

			underlineGrid.lineTo( size + 150, -size );
			underlineGrid.lineTo( size + 150, -150 );

			underlineGrid.lineTo( size, 0 );

			underlineGrid.lineTo( size, size );
			underlineGrid.lineTo( -size, size );

			underlineGrid.lineTo( -size, 0 );
			underlineGrid.lineTo( 0, 0 );

			var activateHalfSize = false;
			var offsetXPositive = 0;
			var initialHalfSizeleftright = 0,initialHalfSizetopbottom = 0;  // #  adds addiitional line to end of half way point
			// #  Loop throuhg our verticies to create the grid.
			for ( var i = - size; i <= size; i += step ) {
				if(i == 0) // #  midway point
				{
					activateHalfSize = true;
				}
				if(activateHalfSize)
				{
					if(initialHalfSizeleftright == 0 && initialHalfSizetopbottom == 0) {
						// finishing line
						geometry.vertices.push( new THREE.Vector3(   size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
						geometry.vertices.push( new THREE.Vector3( i, 0,   size / step ) );

						// begin turn
						geometry.vertices.push( new THREE.Vector3( i + size / 2, 0,   size / 2 ) );
						geometry.vertices.push( new THREE.Vector3( i, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( size + size / 2, 0, size / 2 ) );
						geometry.vertices.push( new THREE.Vector3( i + size, 0, i) );

						initialHalfSizeleftright = 1,initialHalfSizetopbottom = 1;
					} else {
						offsetXPositive = size - i;
						if(offsetXPositive >= 150) {
							geometry.vertices.push( new THREE.Vector3( i, 0, i ) );
							geometry.vertices.push( new THREE.Vector3( size + i, 0, i ) );

							geometry.vertices.push( new THREE.Vector3( i , 0,  0 ) );

							if(offsetXPositive == 150) {
								geometry.vertices.push( new THREE.Vector3( i , 0,  size ) );
							} else {
								geometry.vertices.push( new THREE.Vector3( i , 0,  i ) );
							}
						} else {
							geometry.vertices.push( new THREE.Vector3( 150, 0, i ) );
							geometry.vertices.push( new THREE.Vector3( size + 150, 0, i ) );

							geometry.vertices.push( new THREE.Vector3( i , 0,  0 ) );
							geometry.vertices.push( new THREE.Vector3( i , 0,  size ) );

							if(i == size) {
								geometry.vertices.push( new THREE.Vector3( i + 50 , 0,  50 ) );
								geometry.vertices.push( new THREE.Vector3( i + 50 , 0,  size ) );

								geometry.vertices.push( new THREE.Vector3( i + 100 , 0,  100 ) );
								geometry.vertices.push( new THREE.Vector3( i + 100 , 0,  size ) );

								geometry.vertices.push( new THREE.Vector3( i + 150 , 0,  150 ) );
								geometry.vertices.push( new THREE.Vector3( i + 150 , 0,  size ) );

								// geometry.vertices.push( new THREE.Vector3( i + 200 , 0,  200 ) );
								// geometry.vertices.push( new THREE.Vector3( i + 200 , 0,  size ) );
							}
						}

						geometry.vertices.push( new THREE.Vector3( i , 0,  - size ) );
						geometry.vertices.push( new THREE.Vector3( i , 0,  0 ) );
					}
				}
				else {
					// #  Left to right
					geometry.vertices.push( new THREE.Vector3(  size, 0, i ) );
					geometry.vertices.push( new THREE.Vector3(   -size, 0, i ) );
					// #  Up and Down
					geometry.vertices.push( new THREE.Vector3( i, 0, -size ) );
					geometry.vertices.push( new THREE.Vector3( i, 0,   0 ) );
				}
			}
		} else if (gridtype == "JOCO"){
			if(isMini) {
				return this.buildMiniJOCO(modelStep,modelSize,gridtype)
			}

			underlineGrid.moveTo( size, 50 );
			underlineGrid.lineTo( size, -size / 2 );
			underlineGrid.lineTo( size / 2, -size / 2 );
			underlineGrid.lineTo( size / 2, 50 );

			underlineGrid.lineTo( -size + 100, 50 );
			underlineGrid.lineTo( -size + 100, -50 );
			underlineGrid.lineTo( -size, -50 );
			underlineGrid.lineTo( -size, size );

			underlineGrid.lineTo( size, size );
			underlineGrid.moveTo( size, 50 );

			// #  Loop throuhg our verticies to create the grid.
			for ( var i = - size; i <= size; i += step ) {
				if(i >= 150) {
					geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
					geometry.vertices.push( new THREE.Vector3( i, 0,   size / 2 ) );
					if(i == 150) {
						geometry.vertices.push( new THREE.Vector3( size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( 150, 0, i ) );
					}
				} else {
					if(i < 0) {
						// Verticle Lines
						geometry.vertices.push( new THREE.Vector3( i, 0, -50 ) );
						geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
						if (i < -150) {
							geometry.vertices.push( new THREE.Vector3( i, 0, -50 ) );
							geometry.vertices.push( new THREE.Vector3( i, 0, 50) );
						}
						// Horizontal Lines
						geometry.vertices.push( new THREE.Vector3( size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( -size, 0, i ) );
					} else {
						// Horizontal Lines
						geometry.vertices.push( new THREE.Vector3( size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( 150, 0, i ) );
						// Verticle lines
						geometry.vertices.push( new THREE.Vector3( i, 0, -50 ) );
						geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
						if(i < 100 ) {
							geometry.vertices.push( new THREE.Vector3( -size, 0, i ) );
							geometry.vertices.push( new THREE.Vector3( -200, 0, i ) );
						}
					}
				}
			}
		}
		var response = [];
		response['geometry'] = geometry;
		response['buildingShape'] = underlineGrid;
		return response;
	  },
	  buildMiniTLD: function(modelStep,modelSize,gridtype) {
		var size = parseInt(modelSize - 100), halfSize = Math.round(size / 2),step = parseInt(modelStep);
		var geometry = new THREE.Geometry();
		var underlineGrid = new THREE.Shape();
		  // #  Create top right L section
		underlineGrid.moveTo( size, -size );
		underlineGrid.lineTo( size, size );
		underlineGrid.lineTo( -size, size );
		underlineGrid.lineTo( -size, 0 );
		// #  Start the bottom section
		underlineGrid.lineTo( 0, 0);
		underlineGrid.lineTo( 0, -size );
		underlineGrid.lineTo( size, -size );

		var activateHalfSize = false;
		var offsetXPositive = 0;
		var initialHalfSizeleftright = 0,initialHalfSizetopbottom = 0;  // #  adds addiitional line to end of half way point
		// #  Loop throuhg our verticies to create the grid.
		for ( var i = - size; i <= size; i += step ) {
			if(i == 0) // #  midway point
			{
				activateHalfSize = true;
			}
			if(activateHalfSize)
			{
				if(initialHalfSizeleftright == 0 && initialHalfSizetopbottom == 0) {
					// finishing line
					geometry.vertices.push( new THREE.Vector3(   size, 0, i ) );
					geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
					geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
					geometry.vertices.push( new THREE.Vector3( i, 0,   size / step ) );

					// begin turn
					geometry.vertices.push( new THREE.Vector3( i + size / 2, 0,   size / 2 ) );
					geometry.vertices.push( new THREE.Vector3( i, 0, i ) );

					geometry.vertices.push( new THREE.Vector3( size + size / 2, 0, size / 2 ) );
					geometry.vertices.push( new THREE.Vector3( i + size, 0, i) );

					initialHalfSizeleftright = 1,initialHalfSizetopbottom = 1;
				} else {
					offsetXPositive = size - i;
					if(offsetXPositive >= 200) {
						geometry.vertices.push( new THREE.Vector3( i, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( size + i, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( i , 0,  0 ) );
						if(offsetXPositive == 200) {
							geometry.vertices.push( new THREE.Vector3( i , 0,  size ) );
						} else {
							geometry.vertices.push( new THREE.Vector3( i , 0,  i ) );
						}
					} else {
						geometry.vertices.push( new THREE.Vector3( 200, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( size + 200, 0, i ) );

						geometry.vertices.push( new THREE.Vector3( i , 0,  0 ) );
						geometry.vertices.push( new THREE.Vector3( i , 0,  size ) );

						if(i == size) {
							geometry.vertices.push( new THREE.Vector3( i + 50 , 0,  50 ) );
							geometry.vertices.push( new THREE.Vector3( i + 50 , 0,  size ) );

							geometry.vertices.push( new THREE.Vector3( i + 100 , 0,  100 ) );
							geometry.vertices.push( new THREE.Vector3( i + 100 , 0,  size ) );

							geometry.vertices.push( new THREE.Vector3( i + 150 , 0,  150 ) );
							geometry.vertices.push( new THREE.Vector3( i + 150 , 0,  size ) );

							geometry.vertices.push( new THREE.Vector3( i + 200 , 0,  200 ) );
							geometry.vertices.push( new THREE.Vector3( i + 200 , 0,  size ) );
						}
					}

					geometry.vertices.push( new THREE.Vector3( i , 0,  - size ) );
					geometry.vertices.push( new THREE.Vector3( i , 0,  0 ) );
				}
			}
			else {
				// #  Left to right
				geometry.vertices.push( new THREE.Vector3(  size, 0, i ) );
				geometry.vertices.push( new THREE.Vector3(   -size, 0, i ) );
				// #  Up and Down
				geometry.vertices.push( new THREE.Vector3( i, 0, -size ) );
				geometry.vertices.push( new THREE.Vector3( i, 0,   0 ) );
			}
		}
		var response = [];
		response['geometry'] = geometry;
		response['buildingShape'] = underlineGrid;
		return response;
	  },
	  buildMiniJOCO: function(modelStep,modelSize,gridtype) {
		var size = parseInt(modelSize - 100), halfSize = Math.round(size / 2),step = parseInt(modelStep);
		var geometry = new THREE.Geometry();
		var underlineGrid = new THREE.Shape();
		  // #  Create top right L section
		// #  Create top right L section
		underlineGrid.moveTo( -size, -size );
		underlineGrid.lineTo( -size, size );
		underlineGrid.lineTo( size, size );
		underlineGrid.lineTo( size, 0 );
		// #  S tart the bottom section
		underlineGrid.lineTo( 0, 0);
		underlineGrid.lineTo( 0, -size );
		underlineGrid.lineTo( -size, -size );

		// #  Loop throuhg our verticies to create the grid.
		for ( var i = - size; i <= size; i += step ) {
			if(i >= 200) {
				geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
				geometry.vertices.push( new THREE.Vector3( i, 0,   size / 2 ) );
			} else {
				if(i < 0) {
					// Verticle Lines
					geometry.vertices.push( new THREE.Vector3( i, 0, -50 ) );
					geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
					if (i < -150) {
						geometry.vertices.push( new THREE.Vector3( i, 0, -50 ) );
						geometry.vertices.push( new THREE.Vector3( i, 0, 50) );
					}
					// Horizontal Lines
					geometry.vertices.push( new THREE.Vector3( size, 0, i ) );
					geometry.vertices.push( new THREE.Vector3( -size, 0, i ) );
				} else {
					// Horizontal Lines
					geometry.vertices.push( new THREE.Vector3( size, 0, i ) );
					geometry.vertices.push( new THREE.Vector3( 200, 0, i ) );
					// Verticle lines
					geometry.vertices.push( new THREE.Vector3( i, 0, -50 ) );
					geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
					if(i < 100 ) {
						geometry.vertices.push( new THREE.Vector3( -size, 0, i ) );
						geometry.vertices.push( new THREE.Vector3( -200, 0, i ) );
					}
					if(i == 150) {
						geometry.vertices.push( new THREE.Vector3( size, 0, i + 50 ) );
						geometry.vertices.push( new THREE.Vector3( 200, 0, i + 50 ) );
					}
				}
			}
		}
		var response = [];
		response['geometry'] = geometry;
		response['buildingShape'] = underlineGrid;
		return response;
	  }
});

export let floorPlanRenderer = new FloorPlanRenderer();


// WEBPACK FOOTER //
// app/core/graphic_engine/controllers/FloorPlanRenderer.js